module.exports = __webpack_public_path__ + "static/foreman-logo-ca46e566290afa40f59a6d0f9547b80c.png";